<template>
  <resizable-common-dialog
      ref="dialog"
      title="Branch"
      :dialog-visible.sync="visible"
      rules="rules"
      start-dialog-height="460"
      start-dialog-width="420"
  >
    <template v-slot:body>
      <v-row dense>
        <v-col cols="12" md="12" sm="12" class="mb-n5">
          <v-row dense class="mt-3">
            <v-col cols="12" md="12" sm="12">
              <v-text-field disabled label="UID:" v-model.trim="model.uid" hide-details outlined dense/>
            </v-col>
          </v-row>
        </v-col>
        <v-row dense class="mt-3">
          <v-col cols="16" md="8" sm="8">
            <v-text-field
                label="Name:"
                v-model.trim="model.name"
                v-ascii-only
            />
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field
                label="Order:"
                v-model.number="model.order"
            />
          </v-col>
        </v-row>
        <c-group-table :readonly="readonly" :items.sync="model.groups"></c-group-table>
      </v-row>
    </template>

    <template v-slot:actions>
      <v-btn @click="hide" color="blue darken-1" text>Cancel</v-btn>
      <v-btn @click="save" color="blue darken-1" text>Save</v-btn>
    </template>
  </resizable-common-dialog>
</template>

<script>
import {ViewRules} from "@/common/ViewRules";
import VueTypes from "vue-types";
import ResizableCommonDialog from "@/modules/common/dialog/resizable-common-dialog.vue";
import {BranchModel} from "@/modules/mconfigs/models/BranchModel";
import CGroupTable from "@/modules/mconfigs/views/branch/c-group-table.vue";

export default {
  name: "c-branch-dialog",
  components: {CGroupTable, ResizableCommonDialog},
  data: () => ({
    visible: false,
    rules: ViewRules.READONLY,
    model: VueTypes.objectOf(BranchModel),
    resolve: null,
    reject: null,
    newGroup: "",
  }),
  methods: {
    show(rule, model) {
      this.rules = rule;
      this.model = model || new BranchModel();
      this.visible = true;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    hide() {
      this.visible = false;
    },
    save() {
      let error = this.model.valid();

      if (error !== null) {
        this.$notify({title: 'Validation Error', text: error, type: "error"});
        return;
      }

      this.visible = false;
      this.resolve && this.resolve(this.model);
    },
  },
  computed: {
    readonly() {
      return !(this.rules.update || this.rules.create);
    }
  }
}

</script>